import AppsComponent from '../components/AppsComponent.js';
import underDevelopment from '../img/under development.jpg';

function Apps () {
    return(
        <div className="row apps-wrap">
                    <AppsComponent img={underDevelopment} appName="Coming soon" hrefApp={undefined}
                    hrefCode={undefined}
                    appSkills = {{
                    skillName: [undefined],
                    skillPorcentage: [undefined],
                    SkillColor: [undefined]
                    }} /> 
                    
                    <AppsComponent img={underDevelopment} appName="Coming soon" hrefApp={undefined}
                    hrefCode={undefined}
                    appSkills = {{
                    skillName: [undefined],
                    skillPorcentage: [undefined],
                    SkillColor: [undefined]
                    }} /> 
                    <AppsComponent img={underDevelopment} appName="Coming soon" hrefApp={undefined}
                    hrefCode={undefined}
                    appSkills = {{
                    skillName: [undefined],
                    skillPorcentage: [undefined],
                    SkillColor: [undefined]
                    }} />
                    <AppsComponent img={underDevelopment} appName="Coming soon" hrefApp={undefined}
                    hrefCode={undefined}
                    appSkills = {{
                    skillName: [undefined],
                    skillPorcentage: [undefined],
                    SkillColor: [undefined]
                    }} /> 
                    <AppsComponent img={underDevelopment} appName="Coming soon" hrefApp={undefined}
                    hrefCode={undefined}
                    appSkills = {{
                    skillName: [undefined],
                    skillPorcentage: [undefined],
                    SkillColor: [undefined]
                    }} />       
                </div>
    );
} 

export default Apps;